export default {
  "content": "<path d=\"M9.707 13.707L6.914 16.5H20v2H6.914l2.793 2.793-1.414 1.414-4.5-4.5a1 1 0 01-.066-1.34l.066-.074 4.5-4.5 1.414 1.414zM20.207 5.793l.066.073a1 1 0 01-.066 1.341l-4.5 4.5-1.414-1.414L17.086 7.5H4v-2h13.086l-2.793-2.793 1.414-1.414 4.5 4.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};